module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors
    },
    on: {
      "save": _vm.refreshStatusOrder
    }
  }, [_c('div', {
    staticClass: "l-row",
    attrs: {
      "slot": "auth"
    },
    slot: "auth"
  }, [_c('form-group', {
    attrs: {
      "label": "Ambiente",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.environment),
      expression: "config.auth.environment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.auth, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sandbox"
    }
  }, [_vm._v("Sandbox")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "production"
    }
  }, [_vm._v("Produção")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Email"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.email),
      expression: "config.auth.email"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.config.auth.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Token"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.token),
      expression: "config.auth.token"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "token", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('product-price-configuration', {
    attrs: {
      "input": _vm.config.product.price
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor de estoque padrão"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.stock.reducer),
      expression: "config.product.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.product.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.product.stock, "reducer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Formato de envio das categorias"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.category.format),
      expression: "config.category.format"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.category, "format", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('name.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fullNameHierarch"
    }
  }, [_vm._v(_vm._s(_vm.$t('fullNameHierarch.label')))])]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define como serão enviadas as categorias dos produtos.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Envio de gênero nas categorias"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.category.gender),
      expression: "config.category.gender"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.category.gender) ? _vm._i(_vm.config.category.gender, null) > -1 : (_vm.config.category.gender)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.category.gender,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.category, "gender", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.category, "gender", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.category, "gender", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Adiciona o gênero do produto na raiz da árvore de categorias enviadas para o marketplace.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Envio de faixa etária nas categorias"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.category.ageGroup),
      expression: "config.category.ageGroup"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.category.ageGroup) ? _vm._i(_vm.config.category.ageGroup, null) > -1 : (_vm.config.category.ageGroup)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.category.ageGroup,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.category, "ageGroup", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.category, "ageGroup", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.category, "ageGroup", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Adiciona a faixa etária do produto na raiz da árvore de categorias enviadas para o marketplace.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Utilizar um produto por variação"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.singleVariation),
      expression: "config.product.singleVariation"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.product.singleVariation) ? _vm._i(_vm.config.product.singleVariation, null) > -1 : (_vm.config.product.singleVariation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.product.singleVariation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.product, "singleVariation", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.product, "singleVariation", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.product, "singleVariation", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Transforma cada variação do produto em um produto individual no marketplace.")])])], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Enviar informação de prazo extra"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.forwardCrossDocking),
      expression: "config.product.forwardCrossDocking"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.product.forwardCrossDocking) ? _vm._i(_vm.config.product.forwardCrossDocking, null) > -1 : (_vm.config.product.forwardCrossDocking)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.product.forwardCrossDocking,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.product, "forwardCrossDocking", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.product, "forwardCrossDocking", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.product, "forwardCrossDocking", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se a informação de prazo extra dos produtos será sincronizada com o marketplace.")])])], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('expediter.label')
    }
  }, [_c('expediter-configuration', {
    attrs: {
      "expediter": _vm.config.order.expediter
    }
  })], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Status de pedidos"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('a', {
    staticClass: "btn btn--info",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.refreshStatusOrder()
      }
    }
  }, [_c('i', {
    staticClass: "icon-spinner11"
  })])]), _vm._v(" "), _c('loader', {
    attrs: {
      "loading": _vm.fetching
    }
  }), _vm._v(" "), (_vm.statuses.length) ? _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('invoiced.label')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.forward.status.APPROVED),
      expression: "config.order.forward.status.APPROVED"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order.forward.status, "APPROVED", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statuses), function(status) {
    return _c('option', {
      key: status.code,
      domProps: {
        "value": status.code
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Status que será enviado ao informar os dados da etapa de faturamento.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('shipped.label')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.forward.status.SHIPPED),
      expression: "config.order.forward.status.SHIPPED"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order.forward.status, "SHIPPED", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statuses), function(status) {
    return _c('option', {
      key: status.code,
      domProps: {
        "value": status.code
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Status que será enviado ao informar os dados da etapa de transporte.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('delivered.label')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.forward.status.DELIVERED),
      expression: "config.order.forward.status.DELIVERED"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order.forward.status, "DELIVERED", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statuses), function(status) {
    return _c('option', {
      key: status.code,
      domProps: {
        "value": status.code
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Status que será enviado ao informar os dados da etapa de entrega.")])])], 1) : (!_vm.fetching) ? _c('div', {
    staticClass: "u-bolder u-textCenter t-error"
  }, [_vm._v("Não foi possível buscar os status dos pedidos da Skyhub.")]) : _vm._e()], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('quotation.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('quotation-configuration', {
    attrs: {
      "quotation": _vm.config.quotation,
      "marketplace": _vm.identifier
    }
  })], 1)])]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('order.label')
    }
  }, [_c('order-retrieve-date-configuration', {
    attrs: {
      "orderConfigs": _vm.config.order
    }
  })], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Sincronização"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Sincronizar estoque",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.stock),
      expression: "config.synchronize.stock"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "stock", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os estoques serão sincronizados e atualizados na Skyhub.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sincronizar preço",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.price),
      expression: "config.synchronize.price"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "price", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os preços serão sincronizados e atualizados na Skyhub.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sincronizar pedidos fullfilment",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.fullfilment),
      expression: "config.synchronize.fullfilment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "fullfilment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se pedidos que possuem fullfilment serão integrados")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1c43816","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Skyhub.vue
// module id = 3419
// module chunks = 0